var Backbone = require('backbone');


module.exports = Backbone.Model.extend({

    defaults: {
        "groupId": null,
        "groupType": null,
        "name": null,
        "description": null,
        "status": null,
        "creationTime": null,
        "creationUser": null,
        "email": null,
        "color": null
    },

    getName: function() {
        return this.get('name');
    },

    getColor: function() {
        return this.get('color');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/groups/groupModel.js
 ** module id = 86
 ** module chunks = 0
 **/